module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-ThinItalic.b03f87b6.woff";